import React from 'react';
import styles from './relatedArticles.module.scss';
import { Resource } from '../Models/ResourceProps';
import FullWidthContainer from '../Layout/Containers/FullWidthContainer';
import TripleColumnContainer from '../Layout/Containers/TripleColumnContainer';
import ResourceComponent from '../Resources/Resource/ResourceComponent';

export interface RelatedArticlesProps {
    articles: Resource[];
}

const RelatedArticlesComponent = ({ articles }: RelatedArticlesProps) => {
    return (
        <section className={styles.relatedArticlesContainer}>
            <FullWidthContainer>
                <TripleColumnContainer>
                    {articles.map((article, index) => {
                        const {
                            authorName,
                            heading,
                            ingress,
                            mainImage,
                            seoUrl,
                            resource_category,
                            publishedAt,
                        } = article;
                        return (
                            <ResourceComponent
                                key={heading + index}
                                mainImage={mainImage}
                                heading={heading}
                                ingress={ingress}
                                resource_category={resource_category}
                                seoUrl={seoUrl}
                                authorName={authorName}
                                publishedAt={publishedAt}
                                isShowAuthor={false}
                            />
                        );
                    })}
                </TripleColumnContainer>
            </FullWidthContainer>
        </section>
    );
};

export default RelatedArticlesComponent;
